module.exports = __webpack_public_path__ + "static/img/jx3.c058ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx3.png
// module id = 3rBM
// module chunks = 0